import {WixMusicWidgetModule} from '../typings/wix-music-widget';
import {container} from './ioc/container';
import {inversifyConfig} from './ioc/inversify.config';
import {services} from './ioc/services';
import {BI_ERRORS} from './logging/errors';
import {logError} from './logging/logging';
import {debugScoped} from './utils/debug';
import {writeOops} from './utils/oops';
import {IWidgetPlayer} from './widget-player/new/services/WidgetPlayer/IWidgetPlayer';
import {reportPerformanceStep} from './widget-player/performance/report-step';

export function widgetPlayer(PlPromise: Promise<WixMusicWidgetModule>) {
  if (typeof window.Wix === 'undefined') {
    logError(BI_ERRORS.widget.content.scripts.wix);
    writeOops();
    return;
  }
  reportPerformanceStep('page-loaded');
  debugScoped('bootstrap', '------- configure container -----');
  inversifyConfig(container);
  debugScoped('bootstrap', '------- init -----');
  const widgetPlayer = container.get<IWidgetPlayer>(services.widgetPlayer);

  widgetPlayer.init(PlPromise);
}
